<div class="rmMultimodificationWrapper">
  <p-splitButton id="splitButtonHeaderRmMultimodification" [ngClass]="{ 'disable-next-button': deactivateNextButton()}"
                 label="{{ 'label.user.rawmaterial.header.import.semi-auto.next' |translate }}" [model]="items"
                 (onClick)="next()"></p-splitButton>
</div>
